<template>
    <photo-book-interior-image-management></photo-book-interior-image-management>
</template>

    <script>
    import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'
    import PhotoBookInteriorImageManagement from '../../../cscomponents/swodt/PhotoBookInteriorImageManagement';
    import PhotoBookInteriorSpreadList from '../../../cscomponents/swodt/PhotoBookInteriorSpreadList';
      import { Tooltip } from 'element-ui'
      export default {
        name: 's09',
        components: {
          [Tooltip.name]: Tooltip,
          PhotoBookInteriorImageManagement,
          PhotoBookInteriorSpreadList,

        },
        methods: {
            allDataValidated: function () {
                
                this.$emit('allowProceed');
            },
        },
        computed: {
            ...mapGetters({
                currentAccount: 'currentAccount',
            }),
        },
        mounted(){
            this.$emit('denyProceed');
            this.allDataValidated();
        },
      };
    </script>